import React, { useRef, useState } from 'react';
import { func, string } from 'prop-types';
import classNames from 'classnames';
import { Image } from '@thd-olt-component-react/image';
import '../../../styles/toggle.scss';

export const HotspotToggle = ({ onToggle, channel }) => {
  const [hidden, setHidden] = useState(false);

  const isMobile = channel === 'mobile' || channel === 'tablet';

  const toggleClasses = classNames({
    toggle: !isMobile,
    'toggle-mobile': isMobile,
  });

  const iconClass = isMobile ? '' : 'toggle-icon';

  // styling in component gives desired mobile positioning vs styling in scss file
  const imageStyle = {
    width: '16px',
    left: '7px',
    top: '7px',
    position: 'absolute'
  };

  // styling in component gives desired mobile positioning vs styling in scss file
  const textStyle = {
    left: '30px',
    top: '6px',
    position: 'absolute'
  };

  const toggleHotspots = () => {
    onToggle(hidden);
    setHidden(!hidden);
  };

  return (
    <>
      <button
        className={toggleClasses}
        onClick={toggleHotspots}
        data-testid="toggle-button"
        type="button"
      >
        <Image
          alt="icon"
          className={iconClass}
          src="https://assets.thdstatic.com/images/v1/product-hotspot-no-shadow.svg"
          style={isMobile ? imageStyle : {}}
          width="32"
          height="32"
        />
        <span style={isMobile ? textStyle : {}}>
          {hidden ? 'Show Tags' : 'Hide Tags'}
        </span>
      </button>
    </>
  );
};
HotspotToggle.displayName = 'HotspotToggle';
HotspotToggle.propTypes = {
  onToggle: func.isRequired,
  channel: string.isRequired
};
